import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { ITAFBookResponse, ITAFBookRequest,ITAFBookListComponent } from './taf-book'
import { TAFBookService } from './taf-book.service';

import {Messages} from 'primeng/primeng';

@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book.component.html',
    template: require('./taf-book.component.html'),
    directives: [ROUTER_DIRECTIVES]
    
})

export class TAFBookComponent implements OnInit, OnDestroy{
    pageTitle: string = 'TAF BOOK';
    errorMessage: string;
    options:Array<ITAFBookListComponent>;
    selectedOption: ITAFBookListComponent;
    facReportListResponse : ITAFBookResponse[];
    msgs: Messages[]=[];
    cols: any[];
    request : ITAFBookRequest ;
    displaySpinner :boolean=false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBookService: TAFBookService
               
               ) {
                    
    }

    ngOnInit(): void{
        this.selectedOption= new ITAFBookListComponent(1, 'TABLE S-1: Enplanements at Large Hub Airports');
        this.options = [
                    new ITAFBookListComponent(1, 'TABLE S-1: Enplanements at Large Hub Airports'),
                    new ITAFBookListComponent(2, 'GRAPH S-1: Enplanements Growth Rates for the Core Airports'),
                    new ITAFBookListComponent(3, 'TABLE S-2: Airport Operations at the Large Hub Airports '),
                    new ITAFBookListComponent(4, 'GRAPH S-2: Airport Operations Growth Rates for the Core Airports'),
                    new ITAFBookListComponent(5, 'TABLE S-3: Air Traffic Control Towers and Contract Towers by Region and State'),
                    new ITAFBookListComponent(6, 'TABLE S-4: Ranking of Top 100 FAA Towers by Total Enplanements, FY 2016   '),
                    new ITAFBookListComponent(7, 'TABLE S-5: Summary of Enplanements and Airport Operations at FAA Towers and Contract Towers '),
                    new ITAFBookListComponent(8, 'TABLE S-6:Commercial Airport Operations Summary by Region '),
                    new ITAFBookListComponent(9, 'TABLE S-7: Itinerant Airport Operations Summary by Region '),
                    new ITAFBookListComponent(10, 'TABLE S-8:Total Airport Operations Summary by Region '),
                    new ITAFBookListComponent(11, 'TABLE S-9:Tracon Operations Summary by Region '),
                    new ITAFBookListComponent(12, 'TABLE S-10: Enplanements Summary by Region '),
                    new ITAFBookListComponent(13, 'TABLE S-11: Based Aircraft Summary by Region '),
                    new ITAFBookListComponent(14, 'TABLE B-1: List of Large Hub Towers'),
                    new ITAFBookListComponent(15, 'TABLE B-2: List of Medium Hub Towers'),
                    new ITAFBookListComponent(16, 'TABLE B-3: List of Small Hub Towers'),
                    new ITAFBookListComponent(17, 'TABLE B-4: List of Non-Hub Towers'),
                    new ITAFBookListComponent(18, 'TABLE B-5:  List of FAA Contract Towers')
                ];
        this.request = new ITAFBookRequest(1);
    }
    getValue(optionid:number) {
      this.selectedOption = this.options.filter((item)=> item.id == optionid)[0];
      //console.log("get value" + this.selectedOption.id);
   }
   generateReport(){
       this.msgs=[];
       this.displaySpinner = true;
       this.request.tafBookId = this.selectedOption.id;
       this._tafBookService.generateTafBook(this.request)
                .subscribe(
                response => {
                    this.displaySpinner = false;
                    this.facReportListResponse = response;
                    if (this.facReportListResponse[0].responseStatus === 'ERROR') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error has occurred executing your request'
                                        +this.facReportListResponse[0].responseMessage});
                    }
                    else if (this.facReportListResponse[0].responseMessage === 'No Data') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Info Message', detail: 'No Data returned.'
                                        +this.facReportListResponse[0].responseMessage});
                        this.facReportListResponse[0].pdfFileUrl="";
                        this.facReportListResponse[0].htmlFileUrl="";
                    }
                    else{
                        this.msgs=[];
                        this.msgs.push({severity:'info', summary:'Info Message', detail: 'PDF & HTML file generated; please click links below' });
                        this.cols = [
                                    {field: "htmlFileUrl", header: 'Html'},
                                    {field: "pdfFileUrl", header: 'Pdf'},
                        ]
                    }
                    //console.log ("response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
                    //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
                    //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
                },
                error => this.errorMessage = <any>error
                );
   }
   openPDFFile(responsepdf:any){
        window.open(responsepdf, '_blank');
   }
   openHTMLFile(responseHtml:any){
        window.open(responseHtml, '_blank');
  }
    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book.component.ts
 **/